import {useLocation} from '@github-ui/react-router'

import {repoSidebarLinks} from './repos-issues-sidebar-links'

export function useIssuesSidebarState() {
  const {search} = useLocation()

  const searchParams = new URLSearchParams(search)
  const currentQuery = searchParams.get('q')?.trim() ?? ''
  const selectedLink = repoSidebarLinks.find(link => link.query === currentQuery)?.id ?? ''

  return {selectedLink}
}
